import { AbstractSettings, AbstractSettingsDef, SettingsRegistry } from "@mcleod/core";

export interface MarketInsightSettingsDef extends AbstractSettingsDef {
    username: string;
    password: string;
}

export class MarketInsightSettings extends AbstractSettings {
    constructor() {
        super("market_insight_settings");
    }

    public static getSingleton(): MarketInsightSettings {
        return SettingsRegistry.get().getObject("market_insight_settings") as MarketInsightSettings;
    }

    public static get(): MarketInsightSettingsDef {
        return MarketInsightSettings.getSingleton().values as MarketInsightSettingsDef;
    }

    public override get values(): MarketInsightSettingsDef {
        return super.values as MarketInsightSettingsDef;
    }

    protected getValuesInternal(): MarketInsightSettingsDef {
        return this._values as MarketInsightSettingsDef;
    }

    public getUserName(): string {
        return this.values?.username;
    }

    public getPassword(): string {
        return this.values?.password;
    }
}
